
<section class="w3l-form-25">
  <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1>{{'Accounting Reports' | translate }}</h1>
          <p>{{'Select your report from the menu' | translate }}</p>
      </div>
</div>
</section>
<section class="w3l-hero-headers-11 p-sticky-md">
  <div class="top-header">
          <div class="d-grid grid-columns-top-3">
              <div class="accounts">
                  <ul>
                      <li></li>
                      <li></li>
                  </ul>
              </div>

          </div>
  </div>
</section>
<div class="w3l-form-25">
  <BR>
      <label style="width: 250px;">   </label>
      <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
      <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
    </div>
<div id="w3l-appointment">
  <section class="appointment-section section-gap">

    <div class="wrapper">
            <div class="appointment-form">
                <form action="#" method="post">
                  <div class="fields-grid">
                    <label  style="width:20%;height: 70px; font-size: 35px;font-weight: bold;color: darkcyan;">{{'Expenses' | translate }}</label>
                  </div>
                    <div class="fields-grid">
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="stores" (click)="ExpensesReport()" style="height: 100px;width:30%;font-weight: bold;color: darkcyan;" ><i class="fa fa-outdent" style='font-size:48px;color:darkcyan'></i>  {{'Expenses from Date To Date' | translate }}</button>
                         </a>
                        <label  style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="revenue" (click)="ExpensesbySupplierReport()" style="height: 100px;width:30%;font-weight: bold;color: darkcyan;"><i class="fa fa-address-card" style='font-size:48px;color:darkcyan'></i>  {{'Expenses by Supplier' | translate }}</button>
                          </a>
                        <label style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="expenses" (click)="ExpensesbyClassReport()" style="height: 100px;width:30%;font-weight: bold;color: darkcyan;"><i class="fa fa-window-restore" style='font-size:48px;color:darkcyan'></i>  {{'Expenses by Type' | translate }}</button>
                      </a>
                      </div>
                      <br>
                      <div class="fields-grid">
                        <label  style="width:20%;height: 70px; font-size: 35px;font-weight: bold;color: rgb(21, 103, 179);">{{'Revenue' | translate }}</label>
                      </div>
                      <div class="fields-grid">

                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="stores" (click)=" RevenueReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(21, 103, 179);" ><i class="fa fa-indent" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Revenue from Date To Date' | translate }}</button>
                         </a>
                        <label  style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="revenue" (click)=" PatientReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(21, 103, 179);"><i class="fa fa-bed" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Revenue by Patient' | translate }}</button>
                          </a>
                        <label style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="expenses_1" (click)="RevenueTypeReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(21, 103, 179);"><i class="fa fa-tasks" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Revenue by Type' | translate }}</button>
                      </a>

                      </div>

                      <div class="fields-grid">

                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="stores"  (click)="RevenueHospitalReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(21, 103, 179);" ><i class="fa fa-font-awesome" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Revenue By Branch' | translate }}</button>
                         </a>
                        <label  style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="revenue" (click)="RevenueDoctorReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(21, 103, 179);"><i class="fa fa-user-md" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Revenue by Doctor' | translate }}</button>
                          </a>
                        <label style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="expenses" (click)="RevenueExpensesReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(21, 103, 179);"><i class="fa fa-money" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Cash/Bank Transactions' | translate }}</button>
                      </a>
   <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="expenses_1" (click)="VisitsShare()" style="height: 100px;width:30%;font-weight: bold;color: rgb(21, 103, 179);"><i class="fa fa-tasks" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Visits Share from Date to Date' | translate }}</button>
                      </a>
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="expenses_1" (click)="SuppervisionShare()" style="height: 100px;width:30%;font-weight: bold;color: rgb(21, 103, 179);"><i class="fa fa-tasks" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Suppervision Share from Date to Date' | translate }}</button>
                      </a>
                      </div>
                      <br>
                      <div class="fields-grid">
                        <label  style="width:20%;height: 70px; font-size: 35px;font-weight: bold;color: rgb(216, 115, 7);">{{'Patient' | translate }}</label>
                      </div>
                      <div class="fields-grid">

                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="stores"  (click)="PatientAccReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(216, 115, 7);" ><i class="fa fa-pencil-square-o" style='font-size:48px;color:rgb(216, 115, 7)'></i>  {{'Patient Acc. statement' | translate }}</button>
                         </a>
                        <label  style="width:2%;"></label>
                        <a href="PatientInvoices" class="drop-text">
                        <button type="button" class="theme-button btn" name="revenue" style="height: 100px;width:30%;font-weight: bold;color: rgb(216, 115, 7);"><i class="fa fa-file-text-o" style='font-size:48px;color:rgb(216, 115, 7)'></i>  {{'Patient Invoices' | translate }}</button>
                          </a>
                        <label style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                          <button type="button" class="theme-button btn" name="expenses" (click)="SalesReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(216, 115, 7);"><i class="fa fa-file-text" style='font-size:48px;color:rgb(216, 115, 7)'></i> {{'Invoices from Date to Date' | translate }}</button>

                      </a>

                      </div>
                      <div class="fields-grid">

                        <a href="AccRepFillter" class="drop-text">
                          <button type="button" class="theme-button btn" name="expenses" (click)="DiscountReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(216, 115, 7);"><i class="fa fa-list-alt" style='font-size:48px;color:rgb(216, 115, 7)'></i>  {{'Discounts from date to date' | translate }}</button>
                         </a>
                        <label  style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="revenue"  (click)="SalesItem()" style="height: 100px;width:30%;font-weight: bold;color: rgb(216, 115, 7);"><i class="fa fa-list-ol" style='font-size:48px;color:rgb(216, 115, 7)'></i>  {{'Sales By Item' | translate }}</button>
                          </a>
                        <label style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                          <button type="button" class="theme-button btn" name="stores" (click)="SalesItemT()" style="height: 100px;width:30%;font-weight: bold;color: rgb(216, 115, 7);" ><i class="fa fa-th" style='font-size:48px;color:rgb(216, 115, 7)'></i>  {{'Item Sales' | translate }}</button>


                      </a>

                      </div>
                      <br>
                      <div class="fields-grid">
                        <label  style="width:20%;height: 70px; font-size: 35px;font-weight: bold;color: rgb(14, 127, 4);">{{'Stock Control' | translate }}</label>
                      </div>
                      <div class="fields-grid">

                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="stores"  (click)="ItemBalanceReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(14, 127, 4);" ><i class="fa fa-pencil-square-o" style='font-size:48px;color:rgb(14, 127, 4)'></i>  {{'Item Balances' | translate }}</button>
                         </a>
                        <label  style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                        <button type="button" class="theme-button btn" name="revenue" style="height: 100px;width:30%;font-weight: bold;color: rgb(14, 127, 4);" (click)="ItemCardReport()"><i class="fa fa-file-text-o" style='font-size:48px;color:rgb(14, 127, 4)'></i>  {{'Item Card' | translate }}</button>
                          </a>
                        <label style="width:2%;"></label>
                        <a href="AccRepFillter" class="drop-text">
                          <button type="button" class="theme-button btn" name="expenses" (click)="SalesReport()" style="height: 100px;width:30%;font-weight: bold;color: rgb(14, 127, 4);" (click)="PriceList()"><i class="fa fa-file-text" style='font-size:48px;color:rgb(14, 127, 4)'></i> {{'Price List' | translate }}</button>
                      </a>

                      </div>
                    <div class="fields-grid">
                      <a href="Home">
                        <button type="button" class="theme-button btn" style="width: 90%;height: 100px;" name="Back"><i class="fa fa-home" style='font-size:48px;color:rgb(21, 103, 179)'></i>  {{'Home' | translate }}</button>
                       </a>
                    </div>
                </form>
            </div>


        <div class="clear"> </div>
    </div>
</section>
</div>


